import { StandardList } from "@cdkglobal/radial";
import { RenderInventoryBuildingZonesPlainTextListProps } from "../../../../../types";
import { isNewRecord } from "../../../helpers";

export default function RenderInventoryBuildingZonesPlainTextList({
  propertyKey,
  inputValues,
  rowDataReducerState,
}: Readonly<RenderInventoryBuildingZonesPlainTextListProps>): JSX.Element {
  const plainTextValues = inputValues
    .map(({ label, value }) => `${label ?? value ?? ""}`.trim())
    .filter((value) => value.length > 0);

  if (isNewRecord(rowDataReducerState.rowData)) {
    return (
      <div data-testid={`${propertyKey}-readonly-message`}>
        Zones will be available after the building is created.
      </div>
    );
  }

  if (plainTextValues.length === 0) {
    return (
      <div
        data-testid={`${propertyKey}-plain-text-empty`}
        style={{ fontSize: "0.92rem", color: "#888" }}
      >
        No zones assigned to this building.
      </div>
    );
  }

  return (
    <StandardList
      items={plainTextValues.map((value, index) => ({
        text: value,
        key: `${value}-${index}`,
      }))}
    />
  );
}
